import { Theme } from '@mui/material'

type ThemeOptions = {
  theme: Theme
}

export const customComponentOptions = {
  MuiInputBase: {
    styleOverrides: {
      root: ({ theme }: ThemeOptions) => ({
        fontSize: theme.typography['body-12'].fontSize,
        lineHeight: '16.8px',
        fontWeight: 500,
        color: theme.palette['sage-900'],
        borderColor: theme.palette['sage-200'],
        padding: 0,
        borderRadius: theme.borders['rounded-10']
      })
    }
  },
  MuiOutlinedInput: {
    styleOverrides: {
      root: ({ theme }: ThemeOptions) => ({
        borderRadius: theme.borders['rounded-10'],
        '& fieldset': {
          borderColor: theme.palette['sage-200']
        },
        '&.Mui-disabled': {
          backgroundColor: '#FFFFFF',
          color: theme.palette['sage-200'],
          '& .MuiInputBase-input::placeholder': {
            color: theme.palette['sage-200'],
            opacity: 1
          }
        }
      }),
      input: ({ theme }: ThemeOptions) => ({
        '&::placeholder': {
          color: theme.palette['sage-200'],
          opacity: 1
        }
      })
    }
  },
  MuiSelect: {
    styleOverrides: {
      root: ({ theme }: ThemeOptions) => ({
        borderRadius: theme.borders['rounded-10']
      }),
      select: {
        lineHeight: '1.4375em'
      }
    }
  },
  MuiFormHelperText: {
    styleOverrides: {
      root: {
        textTransform: 'none' as const
      }
    }
  },
  MuiButton: {
    styleOverrides: {
      root: ({ theme }: ThemeOptions) => ({
        borderRadius: theme.borders['rounded-10']
      })
    }
  },
  MuiButtonBase: {
    defaultProps: {},
    styleOverrides: {
      root: ({ theme }: ThemeOptions) => ({
        '&.MuiButton-containedPrimary': {
          backgroundColor: theme.palette['accent-500'],
          fontWeight: 600,
          color: theme.palette['sage-900'],
          boxShadow: 'none'
        },
        '&.MuiButton-containedPrimary:hover': {
          backgroundColor: theme.palette['accent-300'],
          fontWeight: 600,
          boxShadow: 'none'
        },
        '&.MuiButton-containedPrimary:focus': {
          backgroundColor: '#5DEAFE',
          fontWeight: 600,
          boxShadow: 'none'
        },
        '&.MuiButton-containedPrimary:disabled': {
          backgroundColor: '#DDDDE7',
          fontWeight: 600
        },
        '&.MuiButton-containedSecondary': {
          backgroundColor: theme.palette['sage-100'],
          fontWeight: 600,
          color: theme.palette['sage-900'],
          boxShadow: 'none'
        },
        '&.MuiButton-containedSecondary:hover': {
          backgroundColor: theme.palette['base-white'],
          fontWeight: 600,
          boxShadow: 'none'
        },
        '&.MuiButton-containedSecondary:focus': {
          backgroundColor: '#E5E4DF',
          fontWeight: 600,
          boxShadow: 'none'
        },
        '&.MuiButton-containedWarning': {
          backgroundColor: '#D80B00',
          fontWeight: 600,
          boxShadow: 'none'
        },
        '&.MuiButton-containedWarning:hover': {
          backgroundColor: '#B70900',
          fontWeight: 600,
          boxShadow: 'none'
        },
        '&.MuiButton-containedWarning:focus': {
          backgroundColor: '#B70900',
          fontWeight: 600,
          boxShadow: 'none'
        },
        '&.MuiButton-outlinedPrimary': {
          border: '1px solid #BFBFC9',
          fontWeight: 600,
          boxShadow: 'none'
        },
        '&.MuiButton-outlinedPrimary:hover': {
          border: '1px solid #8C8C96',
          fontWeight: 600,
          boxShadow: 'none'
        },
        '&.MuiButton-outlinedPrimary:focus': {
          border: '1px solid #28282F',
          fontWeight: 600,
          boxShadow: 'none'
        },
        '&.MuiButton-outlinedPrimary:disabled': {
          border: '1px solid #BFBFC9',
          fontWeight: 600,
          color: '#BFBFC9',
          boxShadow: 'none'
        }
      })
    }
  },
  MuiMenuItem: {
    styleOverrides: {
      root: {
        '&.Mui-selected': {
          backgroundColor: 'rgba(93, 234, 254, 0.25)'
        }
      }
    }
  },
  MuiChip: {
    styleOverrides: {
      root: ({ theme }: ThemeOptions) => ({
        display: 'flex',
        alignItems: 'center',
        padding: '2px 8px',
        borderRadius: '9999px',
        border: `1px solid ${theme.palette['accent-900']}`,
        backgroundColor: theme.palette['base-white'],
        color: theme.palette['sage-500'],
        fontSize: theme.typography['body-10'].fontSize,
        lineHeight: '16px',
        height: 'auto',
        '& .MuiChip-label': {
          padding: 0,
          fontSize: theme.typography['body-10'].fontSize,
          lineHeight: '16px'
        },
        '& .MuiChip-deleteIcon': {
          fontSize: '16px',
          color: theme.palette['sage-500'],
          margin: '0 0 0 6px'
        }
      })
    }
  }
}
